// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.td`
  background: #fff;
  padding: 0.5rem 0.75rem;
`

type Props = {
  children?: any,
  style?: Object
}

const Table = ({ children, style }: Props) => (
  <Component style={style}>{children}</Component>
)

export default Table



// WEBPACK FOOTER //
// ./src/components/Td/index.js